








































import { Vue, Component, Prop, Model } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
  @Model("change") open!: boolean;
  @Prop() title?: string;
  @Prop() subtitle?: string;
  @Prop({ default: "general.cancel" }) cancelText!: string;
  @Prop({ default: "general.save" }) acceptText!: string;
  @Prop({ default: "primary" }) acceptColor!: string;
  @Prop({ default: true }) showCancelButton!: string;
  @Prop({ default: null }) width!: string | number | null;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: true }) primaryAction!: boolean;
}
